import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DietItemModel } from '../../models'

export interface DietItemState {
    DietItem: DietItemModel
    DietItemList: DietItemModel[]
}

const initialState: DietItemState = {
    DietItem: {
        Id: 0,
        CategoryId: 0,
        CategoryName: '',
        ItemNameEnglish: '',
        ItemNames: [
            {
                LanguageId: 2,
                LanguageName: 'मराठी',
                ItemName: '',
            },
            {
                LanguageId: 3,
                LanguageName: 'हिंदी',
                ItemName: '',
            },
            {
                LanguageId: 4,
                LanguageName: 'ગુજરાતી',
                ItemName: '',
            },
        ],
    },
    DietItemList: [],
}

export const DietItemSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setDietItems: (state, action: PayloadAction<DietItemModel[]>) => {
            state.DietItemList = action.payload
        },
        saveDietItem: (state, action: PayloadAction<DietItemModel>) => {
            let model = action.payload
            if (model.Id > 0) {
                let defaultModel: DietItemModel = {
                    Id: model.Id,
                    CategoryId: model.CategoryId,
                    ItemNameEnglish: model.ItemNameEnglish,
                    ItemNames: model.ItemNames,
                }
                let currentModel = state.DietItemList.find((c) => c.Id === model.Id) || defaultModel
                currentModel.CategoryId = model.CategoryId
                currentModel.ItemNameEnglish = model.ItemNameEnglish
                currentModel.ItemNames = [...model.ItemNames]
            } else {
                model.Id = (Math.max(...state.DietItemList.map((c) => c.Id)) || 0) + 1
                state.DietItemList.push(model)
            }
        },
        getDietItemById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: DietItemModel = initialState.DietItem
            if (id > 0) {
                let currentList: DietItemModel[] = state.DietItemList
                model = currentList.find((c) => c.Id === id) || initialState.DietItem
            }

            state.DietItem = model
        },
        deleteDietItems: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: DietItemModel[] = state.DietItemList
                state.DietItemList = currentList.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setDietItems, saveDietItem, getDietItemById, deleteDietItems } =
    DietItemSlice.actions

export default DietItemSlice.reducer
